
module.exports = {
  'header.docs': 'Docs',
  'header.help': 'Help',
  'header.blog': 'Blog',
  'header.changelog': 'ChangeLog',
  'header.search.placeholder': 'Search...',
  'button.edit': 'Edit',
  'title.changelog': 'ChangeLog',
  'title.help': 'Help'
}



// WEBPACK FOOTER //
// ../~/picidae-theme-haier/pages/locale/en-US.js